/* eslint-disable array-callback-return */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-param-reassign */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable prefer-destructuring */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import add from 'date-fns/add';
import { useIntl } from 'react-intl';
import Overlay from 'react-bootstrap/Overlay';
import { useNavigate } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import {
  MdKeyboardArrowUp,
  MdKeyboardArrowDown,
  MdCalendarMonth,
} from 'react-icons/md';
import { debounce } from '../../../api/apiUtils';
import {
  getCitiesApiV2,
  getHotelCitiesApi,
  getLatLngApiV2,
} from '../../../api/hotelApi';
import AppDatePicker from '../../../shared/components/app-date-picker/AppDatePicker';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppAsyncSelect from '../../../shared/components/app-async-select/AppAsyncSelect';
import './HotelSearch.scss';
import {
  API_DATE_FORMAT,
  DATE_FORMAT_WITHOUT_SEPARATION,
  NAVIGATION_ROUTES,
  TODAY_DATE,
} from '../../../shared/constants/Constants';
import {
  formatDate,
  serialize,
  isAfterDate,
  isMobileWidth,
  getNewDate,
  isEmpty,
} from '../../../shared/helper-utils/appUtils';
import {
  getUserAgentId,
  getValueFromAppConfig,
} from '../../../shared/helper-utils/localStorage';
import { countryOptionsForHotelPax } from '../../../shared/constants/CountryOptions';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import { useAppContext } from '../../../saas/AppConfigWrapper';

const DEBOUNCE_DELAY = 500;

const countryOptions = countryOptionsForHotelPax.map((country) => ({
  label: country,
  value: country,
}));

const ADULT_PAX_DICT = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
const CHILD_PAX_DICT = ['0', '1', '2', '3'];

function locationOptions(props) {
  return (
    <div
      onClick={() => props.selectOption(props.data)}
      className={`${
        props.isFocused ? 'modify-location-focused' : ''
      } modify-location-option`}
      key={props.value}
    >
      <div className="d-flex ">
        <div className="d-flex flex-column modify-location-option__other ">
          <span className="modify-location-option__other_location ">
            {`${props.data.label}`}
          </span>
        </div>
      </div>
    </div>
  );
}

function HotelSearch({ previousSearchRequest }) {
  const { appConfig } = useAppContext();
  const agentId = getUserAgentId();
  const navigate = useNavigate();
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const purposeOfTravelOptions = [
    { label: formattedMessage('leisure'), value: '1' },
    { label: formattedMessage('business'), value: '2' },
  ];
  const [errors, setErrors] = useState({});
  const isApiRequestProcessingRef = useRef(false);
  const [defaultLocationList, setDefaultLocationList] = useState([]);
  const cityRef = useRef(null);
  const roomsOverlayTarget = useRef(null);
  const [openRooms, setOpenRooms] = useState(false);
  const isMobileView = useRef(false);
  const [search, setSearch] = useState({
    searchQuery: {
      checkIn: '',
      checkInSearch: '',
      checkOut: '',
      checkOutSearch: '',
      city: '',
      country: '',
      totRoomNights: 1,
      loggedInUserAgentId: agentId,

      purposeOfTravel: '1',
      customerCountry: appConfig?.hotelPaxCountry,
      paxCOR: appConfig?.hotelPaxCountry,
      isAminity: true,
      baseCurrency: appConfig?.appCurrency,
      totrooms: 1,
      totalPeople: 2,
      lat: '',
      lng: '',
      radius: '5000',
      roomRequirements: [
        {
          adults: '2',
          childs: '0',
          childAges: '',
          infants: '0',
          infantAges: '',
        },
      ],
    },
    pagination: {
      currentPage: 0,
      pageSize: 1000,
      stars: '',
      sortBy: '',
      hotelName: '',
      version: 'v2',
      minPrice: 0,
      propertype: '',
      isPostpaid: '',
      maxPrice: 1000000,
    },
    cache: 6,
    searchV3: 'true',
    profileId: '',
    isSBT: '',
  });

  const getLabel = (city) => {
    return <div className="d-flex">{city}</div>;
  };

  useEffect(() => {
    if (previousSearchRequest) {
      cityRef.current = {
        label: getLabel(previousSearchRequest.searchQuery.city),
        value: previousSearchRequest.searchQuery.city,
      };
      setSearch((prevState) => ({
        ...prevState,
        searchQuery: {
          ...prevState.searchQuery,
          city: previousSearchRequest.searchQuery.city,
          country: previousSearchRequest.searchQuery.country,
          checkInSearch: getNewDate(
            previousSearchRequest.searchQuery.checkInSearch,
          ),
          checkOutSearch: getNewDate(
            previousSearchRequest.searchQuery.checkOutSearch,
          ),
          roomRequirements: previousSearchRequest.searchQuery.roomRequirements,
          totrooms: Number(previousSearchRequest.searchQuery.totrooms),
          totalPeople: Number(previousSearchRequest.searchQuery.totalPeople),
          customerCountry: previousSearchRequest.searchQuery.customerCountry,
          paxCOR: previousSearchRequest.searchQuery.paxCOR,
          purposeOfTravel:
            previousSearchRequest.searchQuery.purposeOfTravel || '1',
          lat: previousSearchRequest.searchQuery.lat,
          lng: previousSearchRequest.searchQuery.lng,
          destinationId: previousSearchRequest.destinationId,
          destinationType: previousSearchRequest.destinationType,
        },
        destinationType: previousSearchRequest.destinationType,
      }));
    }
  }, [previousSearchRequest]);

  const handleUpdateSearchState = (name, value) => {
    setSearch((prevState) => ({
      ...prevState,
      searchQuery: {
        ...prevState.searchQuery,
        [name]: value,
      },
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };

  const loadLocationSuggestions = debounce(async (query, callback) => {
    let cities = [];
    if (query.length >= 3) {
      const response = await getCitiesApiV2(query);
      cities = response.predictions
        .filter(
          (cityNode) =>
            !isEmpty(cityNode.place_id) && !isEmpty(cityNode.description),
        )
        .map((cityNode) => ({
          value: `${cityNode?.description.split(',')[0]}`,
          label: cityNode?.description,
          placeId: `${cityNode?.place_id}`,
          country: `${cityNode?.description
            .split(',')
            [cityNode?.description.split(',').length - 1].trim()}`,
          destinationType: cityNode.types,
        }));
    }
    callback(cities);
  }, DEBOUNCE_DELAY);

  const handleLocationSelect = async (city) => {
    cityRef.current = city;
    let cityCode = '';
    let country = '';
    if (city !== null) {
      cityCode = city.value;
      country = city.country;
    }
    handleUpdateSearchState('city', cityCode);
    handleUpdateSearchState('country', country);
    const response = await getLatLngApiV2(city.placeId, city.value);
    const { lat, lng } = response.result.geometry.location;
    handleUpdateSearchState('lat', lat);
    handleUpdateSearchState('lng', lng);
    handleUpdateSearchState('destinationType', city.destinationType);
    handleUpdateSearchState('destinationId', city.placeId);
  };

  const handleDateChange = (date, fieldName) => {
    handleUpdateSearchState(fieldName, date);
    if (fieldName === 'checkInSearch') {
      handleUpdateSearchState(
        'checkOutSearch',
        add(getNewDate(date), { days: 1 }),
      );
    }
  };

  const handleAddRemoveRoom = (shouldRemove) => {
    const roomRequirements = [...search.searchQuery.roomRequirements];
    let totalPeople = search.searchQuery.totalPeople;
    let totrooms = search.searchQuery.totrooms;
    if (shouldRemove) {
      const removedElement = roomRequirements[roomRequirements.length - 1];
      roomRequirements.splice(roomRequirements.length - 1, 1);
      totalPeople -=
        Number(removedElement.adults) +
        Number(removedElement.childs) +
        Number(removedElement.infants);
      totrooms -= 1;
    } else {
      const obj = {
        adults: '1',
        childs: '0',
        childAges: '',
        infants: '0',
        infantAges: '',
      };
      roomRequirements.push(obj);
      totalPeople +=
        Number(obj.adults) + Number(obj.childs) + Number(obj.infants);
      totrooms += 1;
    }
    setSearch({
      ...search,
      searchQuery: {
        ...search.searchQuery,
        roomRequirements,
        totalPeople,
        totrooms,
      },
    });
  };

  const handleRoomRequirementChange = (name, value, index) => {
    if (name === 'adults' && !ADULT_PAX_DICT.includes(value.toString())) return;
    if (name === 'childs' && !CHILD_PAX_DICT.includes(value.toString())) return;
    const roomRequirements = [...search.searchQuery.roomRequirements];
    roomRequirements[index][name] = value.toString();
    if (name === 'childs') {
      // const childages = Array(value).fill(2);
      const childages = Array.from(
        { length: parseInt(value, 10) },
        (_, childindex) => (1).toString(),
      );
      roomRequirements[index].childAges = childages.join(',');
    }
    let totPeople = 0;
    for (const room of roomRequirements) {
      totPeople +=
        parseInt(room.adults, 10) +
        parseInt(room.childs, 10) +
        parseInt(room.infants, 10);
    }
    setSearch((prev) => ({
      ...prev,
      searchQuery: {
        ...prev.searchQuery,
        roomRequirements,
        totalPeople: totPeople,
      },
    }));
  };

  const handleChildAgeChange = (roomIndex, childIndex, value) => {
    const roomRequirements = [...search.searchQuery.roomRequirements];
    const newChildAgeArray = roomRequirements[roomIndex].childAges.split(',');
    newChildAgeArray[childIndex] = value;
    const newChildString = newChildAgeArray.join(',');
    roomRequirements[roomIndex].childAges = newChildString;
    setSearch((prev) => ({
      ...prev,
      searchQuery: {
        ...prev.searchQuery,
        roomRequirements,
      },
    }));
  };

  const handleHotelSearch = () => {
    const errorsObj = {};
    if (search.searchQuery.city === '') {
      errorsObj.city = formattedMessage('city_location_validation');
    }
    if (
      search.searchQuery.checkInSearch === null ||
      search.searchQuery.checkInSearch === undefined ||
      search.searchQuery.checkInSearch === ''
    ) {
      errorsObj.checkInSearch = formattedMessage('check_in_validation');
    }
    if (
      search.searchQuery.checkOutSearch === null ||
      search.searchQuery.checkOutSearch === undefined ||
      search.searchQuery.checkOutSearch === ''
    ) {
      errorsObj.checkOutSearch = formattedMessage('check_out_validation');
    }
    if (
      isAfterDate(
        getNewDate(search.searchQuery.checkInSearch),
        getNewDate(search.searchQuery.checkOutSearch),
      )
    ) {
      errorsObj.sameCheckInCheckOut = formattedMessage(
        'checkout_should_be_greaterthan_checkin',
      );
    }

    setErrors(errorsObj);
    if (Object.keys(errorsObj).length > 0) {
      return true;
    }
    // processing the search query based on requirement needed by backend
    // const country = search.searchQuery.city.split(',')[1].trim();
    const searchRequest = {
      ...search,
      searchQuery: {
        ...search.searchQuery,
        checkIn: formatDate(
          search.searchQuery.checkInSearch,
          DATE_FORMAT_WITHOUT_SEPARATION,
        ),
        checkInSearch: formatDate(
          search.searchQuery.checkInSearch,
          API_DATE_FORMAT,
        ),
        checkOut: formatDate(
          search.searchQuery.checkOutSearch,
          DATE_FORMAT_WITHOUT_SEPARATION,
        ),
        checkOutSearch: formatDate(
          search.searchQuery.checkOutSearch,
          API_DATE_FORMAT,
        ),
        // country,
        loggedInUserAgentId: search.searchQuery.loggedInUserAgentId,
        customerCountry: search.searchQuery.customerCountry,
        paxCOR: search.searchQuery.paxCOR,
      },
    };
    // const queryParam = `city=${searchRequest.city}&checkIn=${searchRequest.checkIn}&checkOut=${searchRequest.checkOut}&people=${searchRequest.people}&room=${searchRequest.room}`;
    const queryParam = serialize(searchRequest.searchQuery);
    navigate(`${NAVIGATION_ROUTES.HOTEL.HOTEL_SEARCH}?${queryParam}`);
  };

  return (
    <Row className="spacing-8">
      {!isMobileWidth() ? (
        <>
          <Col lg={3} md={3} sm={3} xs={12}>
            <AppAsyncSelect
              name="city"
              placeholder={formattedMessage('select_city')}
              label={formattedMessage('location')}
              components={{ Option: locationOptions }}
              selectedValue={cityRef.current}
              loadOptionsFn={loadLocationSuggestions}
              defaultOptions={defaultLocationList}
              onSelect={handleLocationSelect}
              height="54px"
              bgColor="#FFFFFF14"
              padding="8px 14px"
              color="#fff"
            />
            <small className="validation-error">
              {errors.city && errors.city}
            </small>
          </Col>
          <Col lg={2} md={2} sm={2} xs={6}>
            <AppDatePicker
              customClassName="hotel-modify-datepicker"
              labelClassName="hotel-modify-datepicker-label"
              placeholder=""
              label="Check in"
              minDate={getNewDate(TODAY_DATE)}
              dateFormat="dd MMM yyyy"
              monthsShown={isMobileWidth() ? 12 : 2}
              selectedDate={search.searchQuery.checkInSearch}
              onChange={(date) => handleDateChange(date, 'checkInSearch')}
            />
            <small className="validation-error">
              {errors.checkInSearch && errors.checkInSearch}
            </small>
          </Col>
          <Col lg={2} md={2} sm={2} xs={6}>
            <AppDatePicker
              customClassName="hotel-modify-datepicker"
              labelClassName="hotel-modify-datepicker-label"
              placeholder=""
              label="Check out"
              dateFormat="dd MMM yyyy"
              monthsShown={isMobileWidth() ? 12 : 2}
              minDate={
                search.searchQuery.checkInSearch
                  ? add(getNewDate(search.searchQuery.checkInSearch), {
                      days: 1,
                    })
                  : getNewDate(TODAY_DATE)
              }
              selectedDate={search.searchQuery.checkOutSearch}
              onChange={(date) => handleDateChange(date, 'checkOutSearch')}
            />
            <small className="validation-error">
              {errors.checkOutSearch && errors.checkOutSearch}
            </small>
            <small className="validation-error">
              {errors.sameCheckInCheckOut && errors.sameCheckInCheckOut}
            </small>
          </Col>
          <Col lg={2} md={2} sm={2} xs={12}>
            <div
              className="room-select d-flex justify-content-between align-items-center"
              ref={roomsOverlayTarget}
              onClick={() => setOpenRooms(!openRooms)}
            >
              <div className="d-flex flex-column">
                <span className="fs-10" style={{ color: '#e3ecf8' }}>
                  Room and Guest
                </span>
                <span className="fs-14 fw-600 white-color">
                  {`${parseInt(search.searchQuery.totrooms, 10)} ${
                    parseInt(search.searchQuery.totrooms, 10) > 1
                      ? formattedMessage('rooms')
                      : formattedMessage('room')
                  }, ${parseInt(search.searchQuery.totalPeople, 10)} ${
                    parseInt(search.searchQuery.totalPeople, 10) > 1
                      ? formattedMessage('guests')
                      : formattedMessage('guest')
                  }`}
                </span>
              </div>
            </div>
            <Overlay
              rootClose
              target={roomsOverlayTarget.current}
              show={openRooms}
              placement="bottom"
              onHide={() => setOpenRooms(false)}
            >
              {({ placement, arrowProps, show: _show, popper, ...props }) => (
                <div
                  {...props}
                  style={{
                    position: 'absolute',
                    padding: '1rem',
                    borderRadius: '8px',
                    width: isMobileView.current ? '92%' : '320px',
                    backgroundColor: '#FCD18A',
                    zIndex: 9999,
                    marginTop: '8px',
                    maxHeight: '400px',
                    overflowY: 'scroll',
                    ...props.style,
                  }}
                >
                  <div>
                    <div>
                      {search.searchQuery.roomRequirements.map((d, index) => (
                        <div key={index}>
                          <span className="fw-600">{`${formattedMessage(
                            'room',
                          )} ${index + 1}:`}</span>
                          <div className="d-flex gap-1 flex-column my-1">
                            <span className="fs-12 fw-500">
                              {formattedMessage('adults17')}
                            </span>
                            <ul className="num-pax_list d-flex mb-0 fw-500">
                              {ADULT_PAX_DICT.map(
                                (pax) =>
                                  pax !== '0' && (
                                    <li
                                      key={pax}
                                      className={`${
                                        d.adults === pax ? 'selected' : ''
                                      } num-pax_list_item`}
                                      onClick={() =>
                                        handleRoomRequirementChange(
                                          'adults',
                                          pax,
                                          index,
                                        )
                                      }
                                    >
                                      {pax}
                                    </li>
                                  ),
                              )}
                            </ul>
                          </div>
                          <div className="d-flex gap-1 flex-column my-1">
                            <span className="fs-12 fw-500">
                              {formattedMessage('child')}
                            </span>
                            <ul className="num-pax_list d-flex mb-0 fw-500">
                              {CHILD_PAX_DICT.map((pax) => (
                                <li
                                  key={pax}
                                  className={`${
                                    d.childs === pax ? 'selected' : ''
                                  } num-pax_list_item`}
                                  onClick={() =>
                                    handleRoomRequirementChange(
                                      'childs',
                                      pax,
                                      index,
                                    )
                                  }
                                >
                                  {pax}
                                </li>
                              ))}
                            </ul>
                          </div>
                          <div className="d-flex gap-3">
                            {d.childs > 0 &&
                              Array.from({
                                length: parseInt(d.childs, 10),
                              }).map((_, indexOfChild) => (
                                <div key={indexOfChild}>
                                  <div className="my-1 d-flex gap-1 fs-12 flex-column align-items-center">
                                    <label
                                      htmlFor={`child${indexOfChild}`}
                                      className="fw-500"
                                    >
                                      {formattedMessage('child')}{' '}
                                      {indexOfChild + 1}{' '}
                                      {formattedMessage('age')}
                                    </label>
                                    <select
                                      name={`child${indexOfChild}`}
                                      value={
                                        d.childAges.split(',')[indexOfChild]
                                      }
                                      onChange={(e) =>
                                        handleChildAgeChange(
                                          index,
                                          indexOfChild,
                                          e.target.value,
                                        )
                                      }
                                      style={{
                                        border: 'none',
                                        width: 'fit-content',
                                      }}
                                    >
                                      <option value="1">1</option>
                                      <option value="2">2</option>
                                      <option value="3">3</option>
                                      <option value="4">4</option>
                                      <option value="5">5</option>
                                      <option value="6">6</option>
                                      <option value="7">7</option>
                                      <option value="8">8</option>
                                      <option value="9">9</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                    </select>
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="d-flex mt-2">
                      <AppButton
                        btnText={formattedMessage('add_room_btn')}
                        onClick={() => handleAddRemoveRoom(false)}
                        variant="secondary"
                        className="height-40"
                        disabled={
                          search.searchQuery.roomRequirements.length >= 5
                        }
                      />
                      {search.searchQuery.roomRequirements.length > 1 && (
                        <AppButton
                          btnText={formattedMessage('remove_room')}
                          onClick={() => handleAddRemoveRoom(true)}
                          variant="outlined"
                          className="ms-2 height-40"
                        />
                      )}
                    </div>
                    <div className="d-flex justify-content-end">
                      <AppButton
                        btnText={formattedMessage('done_btn')}
                        onClick={() => setOpenRooms(false)}
                        variant="primary"
                        className="mt-2 px-3"
                      />
                    </div>
                  </div>
                </div>
              )}
            </Overlay>
          </Col>
          <Col lg={3} md={3} sm={3} xs={12} className="d-flex flex-1">
            <div className="d-flex flex-1">
              <AppButton
                variant="primary"
                className="w-100"
                btnText={formattedMessage('hotel_search_btn')}
                onClick={handleHotelSearch}
              />
            </div>
          </Col>
          <Col lg={3} md={3} sm={3} xs={12} className="mt-3">
            <AppSelect
              name="customerCountry"
              placeholder=""
              label={formattedMessage('nationality_select')}
              options={countryOptions}
              selectedValue={search.searchQuery.customerCountry}
              onSelect={(data) =>
                handleUpdateSearchState('customerCountry', data.value)
              }
              isClearable={false}
            />
          </Col>
          <Col lg={3} md={3} sm={3} xs={12} className="mt-3">
            <AppSelect
              name="paxCOR"
              placeholder=""
              label={formattedMessage('residency_select')}
              options={countryOptions}
              selectedValue={search.searchQuery.paxCOR}
              onSelect={(data) => handleUpdateSearchState('paxCOR', data.value)}
              isClearable={false}
            />
          </Col>
          {getValueFromAppConfig('businesshotelflow') === 'true' && (
            <Col lg={3} md={3} sm={3} xs={12} className="mt-3">
              <AppSelect
                name="purposeOfTravel"
                placeholder=""
                label={formattedMessage('purpose_of_travel_select')}
                options={purposeOfTravelOptions}
                selectedValue={search.searchQuery.purposeOfTravel}
                onSelect={(data) =>
                  handleUpdateSearchState('purposeOfTravel', data.value)
                }
                isClearable={false}
              />
            </Col>
          )}
        </>
      ) : (
        <>
          <Col
            lg={3}
            md={3}
            sm={3}
            xs={12}
            className="border-bottom-2 white-color"
          >
            <AppAsyncSelect
              name="city"
              placeholder={formattedMessage('select_city')}
              label={formattedMessage('location')}
              components={{ Option: locationOptions }}
              selectedValue={cityRef.current}
              loadOptionsFn={loadLocationSuggestions}
              defaultOptions={defaultLocationList}
              onSelect={handleLocationSelect}
              height="54px"
              bgColor="#FFFFFF14"
              padding="8px 14px"
              color="#fff"
              selectedTab="hotel"
            />
            <small className="validation-error">
              {errors.city && errors.city}
            </small>
          </Col>
          <Col lg={2} md={2} sm={2} xs={5} className="border-bottom-2">
            <AppDatePicker
              customClassName="hotel-modify-datepicker"
              labelClassName="hotel-modify-datepicker-label"
              placeholder=""
              label="Check in"
              minDate={getNewDate(TODAY_DATE)}
              dateFormat="dd MMM yyyy"
              monthsShown={2}
              selectedDate={search.searchQuery.checkInSearch}
              onChange={(date) => handleDateChange(date, 'checkInSearch')}
            />
            <small className="validation-error">
              {errors.checkInSearch && errors.checkInSearch}
            </small>
          </Col>
          <Col
            lg={2}
            md={2}
            sm={2}
            xs={2}
            className="d-flex justify-content-center align-items-center fs-18 white-color"
          >
            <MdCalendarMonth />
          </Col>
          <Col lg={2} md={2} sm={2} xs={5} className="border-bottom-2">
            <AppDatePicker
              customClassName="hotel-modify-datepicker"
              labelClassName="hotel-modify-datepicker-label d-flex justify-content-end"
              valueClassName="fs-14 fw-600 d-flex justify-content-end"
              placeholder=""
              label="Check out"
              dateFormat="dd MMM yyyy"
              monthsShown={2}
              minDate={
                search.searchQuery.checkInSearch
                  ? add(getNewDate(search.searchQuery.checkInSearch), {
                      days: 1,
                    })
                  : getNewDate(TODAY_DATE)
              }
              selectedDate={search.searchQuery.checkOutSearch}
              onChange={(date) => handleDateChange(date, 'checkOutSearch')}
            />
            <small className="validation-error">
              {errors.checkOutSearch && errors.checkOutSearch}
            </small>
            <small className="validation-error">
              {errors.sameCheckInCheckOut && errors.sameCheckInCheckOut}
            </small>
          </Col>
          <Col
            lg={3}
            md={3}
            sm={3}
            xs={12}
            className="d-flex flex-column mb-sm-0 mb-2 mobile-landingpag"
          >
            <div className="gap-2">
              <div className="fs-10 pb-2 white-color">Rooms</div>
              <div className="d-flex">
                <div
                  className="addremove addremove-left-radius"
                  onClick={() => handleAddRemoveRoom(true)}
                >
                  -
                </div>
                <div className="paxtype">{search.searchQuery.totrooms}</div>
                <div
                  className="addremove addremove-right-radius"
                  onClick={() => handleAddRemoveRoom(false)}
                >
                  +
                </div>
              </div>
            </div>
            {search.searchQuery.roomRequirements.map((d, index) => (
              <>
                <div className="traveler-container mt-2" key={index}>
                  <div className="fs-12 pt-4 white-color">
                    Room: {index + 1}
                  </div>
                  <div className="gap-2">
                    <div className="fs-10 pb-2 white-color">
                      Adult (&gt;12 years)
                    </div>
                    <div className="d-flex">
                      <div
                        className="addremove addremove-left-radius"
                        onClick={() =>
                          handleRoomRequirementChange(
                            'adults',
                            parseInt(d.adults, 10) - 1,
                            index,
                          )
                        }
                      >
                        -
                      </div>
                      <div className="paxtype">{d.adults}</div>
                      <div
                        className="addremove addremove-right-radius"
                        onClick={() =>
                          handleRoomRequirementChange(
                            'adults',
                            parseInt(d.adults, 10) + 1,
                            index,
                          )
                        }
                      >
                        +
                      </div>
                    </div>
                  </div>
                  <div className="gap-2">
                    <div className="fs-10 pb-2 white-color">
                      Child (&lt;12 years)
                    </div>
                    <div className="d-flex">
                      <div
                        className="addremove addremove-left-radius"
                        onClick={() =>
                          handleRoomRequirementChange(
                            'childs',
                            parseInt(d.childs, 10) - 1,
                            index,
                          )
                        }
                      >
                        -
                      </div>
                      <div className="paxtype">{d.childs}</div>
                      <div
                        className="addremove addremove-right-radius"
                        onClick={() =>
                          handleRoomRequirementChange(
                            'childs',
                            parseInt(d.childs, 10) + 1,
                            index,
                          )
                        }
                      >
                        +
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex gap-3 ps-5 flex-wrap">
                  {d.childs > 0 &&
                    Array.from({
                      length: parseInt(d.childs, 10),
                    }).map((_, indexOfChild) => (
                      <div key={indexOfChild}>
                        <div className="my-1 d-flex gap-1 fs-12 flex-column align-items-center">
                          <label
                            htmlFor={`child${indexOfChild}`}
                            className="fw-500 white-color"
                          >
                            {formattedMessage('child')} {indexOfChild + 1}{' '}
                            {formattedMessage('age')}*
                          </label>
                          <select
                            name={`child${indexOfChild}`}
                            value={d.childAges.split(',')[indexOfChild]}
                            onChange={(e) =>
                              handleChildAgeChange(
                                index,
                                indexOfChild,
                                e.target.value,
                              )
                            }
                            style={{
                              width: 'fit-content',
                              paddingBottom: '4px',
                            }}
                          >
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                          </select>
                        </div>
                      </div>
                    ))}
                </div>
              </>
            ))}
          </Col>
          <Col lg={3} md={3} sm={3} xs={12} className="d-flex flex-1">
            <div className="d-flex flex-1">
              <AppButton
                variant="primary"
                className="w-100"
                btnText={formattedMessage('hotel_search_btn')}
                onClick={handleHotelSearch}
              />
            </div>
          </Col>
        </>
      )}
    </Row>
  );
}

HotelSearch.defaultProps = {
  previousSearchRequest: undefined,
};

HotelSearch.propTypes = {
  previousSearchRequest: PropTypes.object,
};

export default HotelSearch;
